import useUserType from 'src/hooks/use-user-type/use-user-type';

const useBrandName = (): string | null => {
  const {isCollegePortalUser} = useUserType();

  return isCollegePortalUser ? 'Lead Generation' : 'Raise Me';
};

export default useBrandName;
